import { useAttrs } from 'vue';

import overridesMap from '#shared/constants/overridesMap';
import kebabToCamel from '#shared/utils/kebabToCamel';
import { useQueryParams } from '~/composables/dumb/useQueryParams';

function isBoolean(value) {
  return typeof value === 'boolean' || ['', 'true', 'false'].includes(value);
}

function isTrue(value) {
  if (typeof value === 'boolean') {
    return value;
  }

  return value === '' || value === 'true';
}

export function useAttrsOverrides() {
  const { isNavSSR } = useEnvProps();
  const attrs = useAttrs();
  const query = useQueryParams();
  let rootAttrs = {};

  if (!isNavSSR) {
    const header = document.getElementById('nav-header');

    if (header) {
      rootAttrs = header.dataset;
    }
  }
  const mergedAttrs = {
    ...attrs,
    ...rootAttrs,
  };

  const normalizedAttrs = Object.entries(mergedAttrs).reduce((acc, [key, value]) => {
    const keyFormatted = kebabToCamel(key);

    return {
      ...acc,
      [keyFormatted]: isTrue(value),
    };
  }, {});
  const overrides = Object.entries(query).reduce((acc, [key, value]) => {
    if (!isBoolean(value)) return acc;
    if (!overridesMap[key]) return acc;

    const keyFormatted = key.replace('_', '');

    return { ...acc, [keyFormatted]: isTrue(value) };
  }, {});

  return {
    ...normalizedAttrs,
    ...overrides,
  };
}
